<template>
<m-pageframe
    title="{organization-label}: Lists"
>
<v-container
    fluid
    style="padding-right: 15px; padding-left: 15px;"
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        <v-menu 
            bottom 
            offset-y
            slot="append-outer"  
        >
        
        <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-dots-vertical
            </v-icon>
                
        </template>
        
        <v-list>
            <v-list-item
                v-on:click="onClickNewList()"
            >
                <v-list-item-title>Create New List...</v-list-item-title>
            </v-list-item>
        
        </v-list>
        
        </v-menu> 
    </v-text-field>

    <v-checkbox
        style="margin-top: -10px"
        label="Show Archived Lists"
        v-model="show_archived_lists"
        v-on:change="update"
    />

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"

        @click:row="onClickEdit"
    >
        
        <template v-slot:item.list_internal_label="{ item }">
            {{listLabel(item)}}
        </template>
        
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>View / Edit...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                 <v-list-item
                    v-on:click="onClickArchive(item)"
                    v-if="!item.is_archived"
                >
                    <v-list-item-title>Archive</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickUnarchive(item)"
                    v-if="item.is_archived"
                >
                    <v-list-item-title>Unarchive</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            show_archived_lists: false,
            results: [],
            headers: [
                { text: 'Internal Label', value: 'list_internal_label'},
                { text: 'Active', value: 'count_active'},
                { text: 'Opt Out(s)', value: 'count_opt_out'},
                { text: 'Total Size', value: 'count_members'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            let params = {
                'organization_id': this.$route.params.organization_id,
                'full_text' : this.full_text,
            };

            if ( !this.show_archived_lists )
                params.is_archived = false;
            
            this.$rc.rest(
                'LIST: /api/v1/lists',
                
                params,
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to search lists');
                },
            );
        },

        onClickArchive(item)
        {
            this.$rc.confirm(
                'Archive List',
                'Archive the list '+item.list_internal_label+'?',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Archive', 'value': 'confirm'},
                ],

                (response) => {
                    if (response != 'confirm') 
                        return;

                    
                    
                    this.$rc.rest(
                        'ARCHIVE: /api/v1/lists/:list_id',
                    
                        {
                            'list_id' : item.list_id
                        },
                    
                        (data) => {
                            this.$rc.snackbar(item.list_internal_label+' archived');
                            this.doUpdate();
                        },
                    
                        () => {
                            this.$rc.alert('Error','Unable to archive list');
                        },
                    );
                }
            );
        },

        onClickUnarchive(item)
        {
            this.$rc.rest(
                'UNARCHIVE: /api/v1/lists/:list_id',
            
                {
                    'list_id' : item.list_id
                },
            
                (data) => {
                    this.$rc.snackbar(item.list_internal_label+' un-archived');
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.alert('Error','Unable to unarchive list');
                },
            );
        },

        listLabel(item)
        {
            if ( item.is_archived )
                return item.list_internal_label + ' (Archived)';
            
            return item.list_internal_label;
        },

        onClickEdit(item)
        {
            this.$router.push({
                'name': 'edit-list',
                'params' : {
                    'list_id' : item.list_id,
                }
            });
        },

        onClickNewList()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'CREATE-NEW: /api/v1/lists/:organization_id',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.onClickEdit(data);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to create new list');
                },
            );

            
        },

      
    },
}
</script>

<style lang="scss" scoped>
</style>